module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', [_vm._v("相关视频:")]), _vm._v(" "), _c('span', {
    staticClass: "video"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', [_vm._v("标题:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.subtitle),
      expression: "item.subtitle"
    }],
    attrs: {
      "placeholder": "请输入标题"
    },
    domProps: {
      "value": (_vm.item.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "subtitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.content),
      expression: "item.content"
    }],
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.item.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "content", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保 存")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd5ce96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/note/editor.vue
// module id = 330
// module chunks = 0